import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "leftAdornment", "rightAdornment", "size", "width", "minWidth", "maxWidth", "mask", "lazy", "placeholderChar", "preprocessInputChars", "defaultValue", "onChange", "blocks"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable import/no-named-as-default */
import * as React from 'react';
import { useEventCallback } from '@cian/react-utils';
import { FocusObserver } from '../../../internal/components/FocusObserver/FocusObserver';
import { IMaskInput } from '../../../internal/components/IMaskInput';
import { InputWrapper } from '../../../internal/components/InputWrapper/InputWrapper';
import { InputWrapperInput } from '../../../internal/components/InputWrapperInput/InputWrapperInput';
import { useControlled } from '../../../internal/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
var MaskedInputComponent = /*#__PURE__*/React.forwardRef(function MaskedInput(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    leftAdornment = props.leftAdornment,
    rightAdornment = props.rightAdornment,
    size = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    mask = props.mask,
    _props$lazy = props.lazy,
    lazy = _props$lazy === void 0 ? false : _props$lazy,
    _props$placeholderCha = props.placeholderChar,
    placeholderChar = _props$placeholderCha === void 0 ? '_' : _props$placeholderCha,
    preprocessInputChars = props.preprocessInputChars,
    defaultValue = props.defaultValue,
    onChange = props.onChange,
    blocks = props.blocks,
    rest = _objectWithoutProperties(props, _excluded);
  var _useControlled = useControlled({
      controlled: props.value,
      default: defaultValue || ''
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var prepareOption = React.useCallback(function (inputChar, masked) {
    return preprocessInputChars ? preprocessInputChars(inputChar, masked.value) : inputChar;
  }, [preprocessInputChars]);
  var options = React.useMemo(function () {
    return {
      mask: mask,
      lazy: !focused || lazy,
      placeholderChar: placeholderChar,
      blocks: blocks,
      prepare: prepareOption
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mask, focused, placeholderChar, prepareOption]);
  var handleInputAccept = useEventCallback(function (nextValue, mask) {
    if (nextValue === value) {
      return;
    }
    setValue(nextValue);
    if (onChange) {
      onChange(nextValue, {
        maskedValue: mask.masked.value
      });
    }
  });
  return /*#__PURE__*/_jsx(InputWrapper, {
    ref: ref,
    focused: focused,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    leftAdornment: leftAdornment,
    rightAdornment: rightAdornment,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    children: /*#__PURE__*/_jsx(FocusObserver, {
      onChange: setFocused,
      children: /*#__PURE__*/_jsx(IMaskInput, _objectSpread(_objectSpread({}, rest), {}, {
        as: InputWrapperInput,
        disabled: disabled,
        options: options,
        onAccept: handleInputAccept,
        value: value
      }))
    })
  });
});
export var MaskedInput = /*#__PURE__*/React.memo(MaskedInputComponent);